import { TValidator } from "../../../wizard/types";

const deactivateFormValidator: TValidator = async ({ values }) => {
  const errors: { [key: string]: any } = {};
  const {
    injectedData: { approved, pending },
  } = values;
  const isReasonRequired = approved + pending > 0;

  if (isReasonRequired && !values.reason?.trim()) {
    errors.reason = "Reason is required";
  }

  if (Object.keys(errors).length > 0) {
    throw errors;
  }
};

export default deactivateFormValidator;
